import React, { Component } from 'react'
import {
  Form,
  Header,
  Message,
  Container,
  Segment,
  Radio
} from 'semantic-ui-react'
import { GoogleSpreadsheet } from "google-spreadsheet";
import {CountryDropdown} from 'react-country-region-selector';
import '../styles/form.css'

import {SPREADSHEET_ID, CLIENT_EMAIL, PRIVATE_KEY, SHEET_ID} from "../secrets/secret.js"

const doc = new GoogleSpreadsheet(SPREADSHEET_ID);



class Register extends Component {
  constructor (props) {
    super(props)

    this.state = {
      submitSuccess: false,
      isLoading: false,
      name: '', 
      country: '', 
      institute: '', 
      designation: '', 
      email: '',
      isNameValid: true,  
      isEmailValid: true,  
    }
  }
  
  appendSpreadsheet = async (row) => {
    try {
      await doc.useServiceAccountAuth({
        client_email: CLIENT_EMAIL,
        private_key: PRIVATE_KEY,
      });
      // loads document properties and worksheets
      await doc.loadInfo();
  
      const sheet = doc.sheetsById[SHEET_ID];
      
      const result = await sheet.addRow(row);
      

      if (result._rowNumber > 1 ) {
        this.setState({submitSuccess: true, isLoading: false})
        this.setState({name: '', country: '', institute: '', designation: '', email: ''})
      }
      
    } catch (e) {
      this.setState({isLoading:false})
      console.error('Error: ', e);
    }
  };

  handleChange = (e, { name, value }) => {
    
    if(name==="name" && typeof name !=='undefined' && name !== "") {
      if(!value.match(/^[a-zA-Z._ \b]+$/)){
        this.setState({isNameValid: false})
      } else {
        this.setState({isNameValid: true})
      }
    }

    this.setState({ [name]: value })
  }

  selectCountry = (val)=>{
    this.setState({country:val})
  }
  
  handleSubmit = e => {
    e.preventDefault()
  
    this.setState({isLoading:true})

    const {
      name,
      email,
      institute,
      designation,
      country,
      isNameValid
    } = this.state

    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    
    if(!email.match(pattern)){

      this.setState({isEmailValid: false, isLoading: false})

    } else {

      this.setState({isEmailValid: true})
    
      if (isNameValid) {
        var newRow = { 
          Name: name, 
          Email: email, 
          Institute: institute, 
          Designation: designation, 
          Country: country 
        };

        this.appendSpreadsheet(newRow)
      };
    }
  }

  render () {
    const {
      name,
      email,
      institute,
      designation,
      country,
      submitSuccess,
      isLoading,
      isNameValid,
      isEmailValid
    } = this.state

    return(
      <div className="pageBG">

        <div className='form_wrapper' id="reg">

        <Container>

          <div className="formHeader">
            
            <Header as='h1' size="huge" id="fh">
              Register for the event
              <Header color="green" as="h3">*The registration is not mandatory for attendance.</Header>
            </Header>
            
          </div>
         
        
           <Segment padded id="form">

            <Form
            className="form"
            size="huge"
            onSubmit={this.handleSubmit}
            success={submitSuccess}
            loading = {isLoading}
            >
            
              {submitSuccess && (
                <Message
                  success
                  header='Registered successfully!'
                  info
                  content='Your registration has been completed successfully.'
                />
              )}

              <div id="ftext">      
               <Form.Input
                  id="name"
                  name='name'
                  fluid
                  label='Name'
                  placeholder='John Doe'
                  onChange={this.handleChange}
                  required
                  type='text'
                  value={name}
                  error={!isNameValid && {
                    content: 'Please enter a valid name using English alphabets',
                    pointing: 'below',
                  }}
                />
            
                <Form.Input
                  id='email'
                  name='email'
                  fluid
                  label='Email'
                  placeholder='abc@example.com'
                  onChange={this.handleChange}
                  required
                  value={email}
                  error={!isEmailValid && {
                    content: 'Please enter a valid email address',
                    pointing: 'below',
                  }}
                />

                <Form.Input 
                id="institute"
                name='institute'
                fluid
                label='Institute'
                placeholder='Affiliated Institute (e.g. IIT Roorkee)'
                onChange={this.handleChange}
                required
                value={institute}
                />

                <Header as="h3" id="desig">Student/ Postdoc/ Faculty <span style={{color:"red"}}>*</span></Header>

                <Form.Group id="rad">                
                <Form.Field
                control={Radio}
                as="h1"
                className="radioo"
                name="designation"
                label='Student'
                value='Student'
                checked={designation === 'Student'}
                onChange={this.handleChange}
                />
                <Form.Field
                control={Radio}
                as="h1"
                className="radioo"
                name="designation"
                label='Postdoc'
                value='Postdoc'
                checked={designation === 'Postdoc'}
                onChange={this.handleChange}
               />
                <Form.Field
                control={Radio}
                as="h1"
                className="radioo"
                name="designation"
                label='Faculty Member'
                value='Faculty Member'
                checked={designation === 'Faculty Member'}
                onChange={this.handleChange}
                />
                </Form.Group>

                <div>
                 <Header as="h3" style={{color: 'white', fontSize: "1em"}}>Country <span style={{color:"red"}}>*</span></Header>
                  <CountryDropdown
                  id="country"
                  value={country}
                  onChange={(val) => this.selectCountry(val)} />
                </div>
              </div>

              {/* Need a check on Country field ?*/}

              <Form.Button 
                color="green"
                inverted
                primary
                size="large"
                content = "Submit"
                id ="submit01"
              />

            </Form>
          
          </Segment>
        </Container>
        </div>
      </div>
    )
  
  }
}

export default Register
